import {Platform, StyleSheet} from 'react-native';
import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default ({colors, typography}: ITheme) => {
  return CreateResponsiveStyle(
    {
      googleButtonStyle: {
        flexDirection: 'row',
        alignItems: 'center',
        width: 285,
        height: 64,
        paddingHorizontal: 16,
        borderRadius: 54,
        shadowColor: colors.black,
        shadowOffset: {
          width: 0,
          height: 3,
        },
        shadowOpacity: 0.1,
        shadowRadius: 3.52,

        elevation: 3,
      },
      googleButtonLabelStyle: {
        marginLeft: 30,
        fontSize: 18,
        lineHeight: 21,
        letterSpacing: 0.5,
        color: Platform.OS == 'web' ? colors.white : colors.osloGray,
        ...typography.robotoMedium,
      },
      imageStyle: {
        width: 32,
        height: 32,
      },
    },
    {
      [maxSize(DEVICE_SIZES.EXTRA_SMALL_DEVICE)]: {
        googleButtonStyle: {
          position: 'absolute',
          bottom: 34,
          backgroundColor: colors.white,
        },
        googleButtonLabelStyle: {
          color: colors.osloGray,
        },
      },
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {
        googleButtonStyle: {
          position: 'relative',
          bottom: 0,
          backgroundColor: colors.white,
        },
        googleButtonLabelStyle: {
          color: colors.cornflowerBlue,
        },
      },
    },
  )();
};
